import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { CustomFieldGroupCollection } from '../index'

export const setupCustomFieldGroupReplication = (
  collection: CustomFieldGroupCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'customfieldgroups',
    displayName: 'CustomFieldGroup',
    collection,
    envId,
    apiEntityName: 'custom-field-groups',
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      customFieldTabId: doc.customFieldTabId,
      name: doc.name,
      description: doc.description ?? null,
      sortOrder: doc.sortOrder ?? null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      customFieldTabId: state.customFieldTabId,
      name: state.name,
      description: state.description,
      sortOrder: state.sortOrder,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
